import { createTheme } from "@material-ui/core/styles";

const FlagstoneTheme = createTheme({
  typography: {
    fontFamily: "\"Helvetica\", \"Arial\", sans-serif"
  },
  palette: {
    primary: {
      main: '#4654FB',
      secondary: '#fafafa'
    },

    secondary: {
      main: '#fafafa',
      secondary: '#4654FB'
    },

    lightGreen:{
      main:'#5CC958',
      secondary:'#fafafa'
    },

    text: {
      primary: '#0C0E29',
      secondary: 'rgba(12, 14, 41, 0.8)',
      tertiary: 'rgba(12, 14, 41, 0.6)',
      light: '#F8F8F8',
    },

    gray: {
      50: "#F8F8F8",
      100: "#EDEDED",
      200: "#DCDCDC",
      300: "#BDBDBD",
      400: "#989898",
      500: "#7C7C7C",
      600: "#656565",
      700: "#525252",
      800: "#464646",
      900: "#3D3D3D",
      950: "#292929"
    },

    blue: {
      50: "#EDF2FF",
      100: "#DEE8FF",
      200: "#C3D3FF",
      300: "#9FB5FF",
      400: "#788DFF",
      500: "#4654FB",
      600: "#3B3AF1",
      700: "#312DD5",
      800: "#2928AB",
      900: "#273088",
      950: "#0C0E29"
    },

    green: {
      50: "#F3FBF2",
      100: "#E2F8E0",
      200: "#C6EFC3",
      300: "#97E194",
      400: "#5CC958",
      500: "#3AB037",
      600: "#2B9128",
      700: "#257223",
      800: "#225B20",
      900: "#1C4B1C",
      950: "#0A290B"
    },

    red: {
      50: "#FDF3F3",
      100: "#FBE5E5",
      200: "#F8D0D0",
      300: "#F2AFAF",
      400: "#E88181",
      500: "#D84949",
      600: "#C73B3B",
      700: "#A72E2E",
      800: "#8A2A2A",
      900: "#742828",
      950: "#3E1111"
    },
  },
});

export default FlagstoneTheme;